import React, {useEffect, useCallback, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {logPageLoadEvents} from '@ibibo/analytics';

import {
  fetchCancellationData,
  fetchCancellationRefundData,
  confirmCancellationApi,

  myTripDetailsParamsSelector,
  activeCancellationTabSelector,
  cancellationDataSelector,
  selectedRefundModeSelector,
  cancellationRefundBreakupDataSelector,

  updateActiveCancellationTab,
  updateCancellationRefundMode
} from '@ibibo/myaccount-reducer';

import * as S from './CancelFlow.styles';

import CancelLeftBlock from '../../../stories/components/CancelFlow/CancelLeftBlock/CancelLeftBlock';
import CancelRightBlock from '../../../stories/components/CancelFlow/CancelRightBlock/CancelRightBlock';
import NoRefundCancelPop from '../../../stories/components/CancelFlow/NoRefundCancelPop/NoRefundCancelPop';
import CancelStatusPop from '../../../stories/components/CancelFlow/CancelStatusPop/CancelStatusPop';

import Modal, {useModal} from '../../../../../hotels-dweb/src/shared/components/Modal';

const CancelFlow = () => {
  const detailsParams = useSelector(myTripDetailsParamsSelector);
  const activeTab = useSelector(activeCancellationTabSelector);
  const cancellationData = useSelector(cancellationDataSelector);
  const selectedRefundMode = useSelector(selectedRefundModeSelector);
  const refundBreakUp = useSelector(cancellationRefundBreakupDataSelector);


  const {
    ivr_msg,
    cp_list = [],
    fb_list = [],
    ra_list = [],
    hotel_name = '',
    image,
    rating = '',
    travel_start_datetime,
    travel_end_datetime,
    rooms,
    room_type,
    paid_amount,
    refund_amount,
    cancelcharges,
    fcdt
  } = cancellationData;

  const hotelDetails = {
    hotelName: hotel_name,
    image,
    checkin: travel_start_datetime ? new Date(travel_start_datetime) : '',
    checkout: travel_end_datetime ? new Date(travel_end_datetime) : '',
    rating,
    rooms,
    roomType: room_type
  };

  const breakupList = {
    cp_list,
    fb_list,
    ra_list
  }

  const freeCancellationText = fcdt ? `Your booking is freely cancellable till ${fcdt}` : '';

  const breakupSummary = {
    paid_amount,
    refund_amount,
    cancelcharges
  }

  const dispatch = useDispatch();

  const [confirmCancelResponse, setConfirmCancelResponse] = useState(null);

  const {isModalOpen: isConfirmModalOpen, closeModal: closeConfirmModal, openModal: openConfirmModal} = useModal();
  const {isModalOpen: isStatusModalOpen, closeModal: closeStatusModal, openModal: openStatusModal} = useModal();

  const fetchCancellationDataCaller = useCallback(() => {
    return dispatch(fetchCancellationData(detailsParams));
  }, [dispatch]);
  
  const fetchCancellationRefundDataCaller = useCallback(() => {
    return dispatch(fetchCancellationRefundData(detailsParams));
  }, [dispatch]);
  
  const confirmCancellationCaller = () => {
    dispatch(confirmCancellationApi(detailsParams, (selectedRefundMode === 'wallet' ? 2 : 1), successCallback, errCallback));
  }

  useEffect(() => {
    fetchCancellationDataCaller();
    fetchCancellationRefundDataCaller();
  }, []);

  useEffect(() => {
    let searchType = '';
    if(cancellationData && cancellationData.hotel_country){
      if(cancellationData.hotel_country !== "india"){
        searchType = 'intl';
      }else{
        searchType = 'domestic';
      }
      logPageLoadEvents(`postbooking:${searchType} hotels mybookings:cancelbooking`, {});
    }
  }, [cancellationData]);


  const successCallback = (resp) => {
    setConfirmCancelResponse(resp);
    openStatusModal();
  }

  const errCallback = (resp) => {
    setConfirmCancelResponse(resp);
    openStatusModal();
  }

  const updateActiveTab = (tab) => {
    dispatch(updateActiveCancellationTab(tab));
  }
  
  const updateRefundMode = (mode) => {
    dispatch(updateCancellationRefundMode(mode));
  }

  const confirmCancellation = () => {
    openConfirmModal();
  }

  const finalConfirmCancellation = () => {
    closeConfirmModal();
    confirmCancellationCaller();
  }

  const navigateToMyTrips = () => {
    window.open('/mytrips/', '_self');
  }

  return(
    <S.CancelMainWrapper>
      <S.CancelOuterWrap>
        <CancelLeftBlock
          selectedRefundMode={selectedRefundMode}
          header={ivr_msg}
          activeTab={activeTab}
          updateActiveTab={updateActiveTab}
          breakupList={breakupList}
          freeCancellationText={freeCancellationText}
          updateRefundMode={updateRefundMode}
          refundBreakUp={refundBreakUp}
          hotelDetails={hotelDetails}
          confirmCancellation={confirmCancellation}
        />
        <CancelRightBlock hotelDetails={hotelDetails} breakupSummary={breakupSummary} />
      </S.CancelOuterWrap>
      <Modal
        isOpen={isConfirmModalOpen}
        closeModal={closeConfirmModal}
        modalStyles={{
          width: 'auto',
        }}
      >
        <NoRefundCancelPop refundAmount={refund_amount} confirmCancellation={finalConfirmCancellation} closeModal={closeConfirmModal} />
      </Modal>
      <Modal
        isOpen={isStatusModalOpen}
        closeModal={navigateToMyTrips}
        modalStyles={{
          width: 'auto',
        }}
      >
        <CancelStatusPop data={confirmCancelResponse} navigateToMyTrips={navigateToMyTrips} />
      </Modal>
    </S.CancelMainWrapper>  
  );
}

export default CancelFlow;